import React, { PropTypes } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router';
import Tooltip from 'react-tooltip';
import { cleanProjectTitle, isMobile } from 'common/utils';
import { isProjectTagline } from 'project/utils';
import ProjectTags from 'common/components/project_tags';
import Breadcrumbs from 'project/containers/breadcrumbs';
import DeadlineLabel from 'project/components/deadline_label';

const STATUS_TAGS = {
  open: { classes: 'tag-highlight success' },
  awarded: { classes: 'awarded' },
  completed: { classes: 'completed' },
  closed: { classes: 'closed' },
  '1_1_negotiating': { classes: 'tag-highlight warning', label: 'pending' },
};

/**
 * Project page specific header title
 *
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 * @author Jing Wang <jing@crowdspring.com>
 */
const HeaderProjectInfo = ({ project, category, subCategory, userId }) => {
  if (!project.id) {
    return null;
  }

  const statusTag = STATUS_TAGS[project.status];
  const statusClasses = statusTag ? (statusTag.classes || 'tag-default') : 'tag-default';
  const statusLabel = statusTag ? (statusTag.label || project.status) : project.status;
  const ownsProject = project.client === userId;

  let papLink;
  if (subCategory.deprecated) {
    papLink = '/categories/';
  } else if (!project.is_one_to_one) {
    papLink = `/${subCategory.slug}/`;
  } else if (!project.mini) {
    papLink = '/1to1-projects/';
  }

  return (
    <div className="row header-middle-content project-middle">
      <div className="small-16 medium-10 columns">
        <Breadcrumbs />

        <div className="project-title">
          { ownsProject? <span className="hide-for-small-only title-description">
            Your <Link to={papLink}>{subCategory.name}</Link> project
          </span> :
          <span className="hide-for-small-only title-description">
            A <Link to={papLink} rel="nofollow">{subCategory.name} </Link>
            project by <Link to={`/users/${project.client_username}/`}>
              {project.client_username}
            </Link>
          </span> }
          <h1 className="middle-left-title">
            { project.is_title_cleanable? cleanProjectTitle(project.title) : project.title }
          </h1>
        </div>
      </div>

      <div className="small-16 medium-6 columns project-status-wrapper">
        <span className={classNames(`tag tag-sm project-status ${statusClasses}`)}>
          {statusLabel}
        </span>
        <ProjectTags project={project} className="project-tags" showColors={false} />
        {project.status === 'open' &&
        <span className="project-duration">
          <DeadlineLabel project={project} />

          { ownsProject &&
          <span>
            <i className="fa fa-info-circle" data-tip={true} data-for="tooltip-deadline"
              data-event={isMobile()? "click" : undefined} />
          </span> }

          <Tooltip class="tooltip" effect="solid" place="right" id="tooltip-deadline"
              delayHide={500}>
            If you've found a { project.entry_type === "image"? "design" :
            (isProjectTagline(project)? "tagline" : "name") } you love and want to close your
            project early to declare a winner, just <Link to="/help/contact/">contact our
            support team</Link> and we'll be happy to help.
          </Tooltip>
        </span>}
      </div>
    </div>
  );
};

HeaderProjectInfo.propTypes = {
  project: PropTypes.shape({
    status: PropTypes.string,
    title: PropTypes.title,
  }),
  category: PropTypes.object,
  subCategory: PropTypes.object,
  userId: PropTypes.number,
};

export default HeaderProjectInfo;



// WEBPACK FOOTER //
// ./project/components/header_title.jsx